import styled from 'styled-components'
import Flex from 'components/Flex'
import { RightOutlined } from '@ant-design/icons'
import { Divider } from 'antd'

export const RightArrow = styled(RightOutlined)`
  cursor: pointer;
  color: #8d8f90;
`
export const StyledFlex = styled.div`
  position: static;
  padding: 5px 48px 5px 20px;
  width: '100%';
  height: auto;
  border-radius: 10px;
  border: 1px solid #e6e7ea;
  margin: 20px 10px;
  box-shadow: 0px 2px 8px rgba(201, 201, 201, 0.1),
    inset 0px -1px 0px rgba(0, 0, 0, 0.05);
`

export const Name = styled.div`
  font-style: normal;
  font-weight: 500;
  font-size: 12px;
  line-height: 15px;

  color: #4d566e;
`

export const Address = styled.div`
  font-weight: 700;
  font-size: 14px;
  line-height: 20px;
  color: #4d566e;
`
export const Address1 = styled.div`
  font-weight: 500;
  font-size: 12px;
  line-height: 15px;
  width:auto;
  text-overflow: ellipsis; 
  color: #1b1f22;
  opacity: 0.48;
`

export const NameAdd = styled(Flex)`
  gap: 4px;
  padding-left: 4px;
`
export const FirstDiv = styled.div`
  height: 60px;
  padding-top: 10px;
  margin-bottom: 10px;
`
export const SecondDiv = styled.div`
  height: 50px;
  padding-top: 10px;
`
export const SubContainer = styled.div`
  position: absolute;
  right: 10%;
`
export const VerticalDivider = styled(Divider)`
  height: 20px;
`
export const ButtonDiv = styled.div`
  display: flex;
  justify-content: end;
  padding-bottom: 20px;
  padding-right: 20px;
`
export const NoDataText = styled.div`
font-style: normal;
font-weight: 700;
font-size: 13px;
line-height: 18px;
color: #999FAC;`

export const CenterButton = styled.div`
display: flex;
justify-content: center;
padding-top: 20px;
padding-bottom: 20px;
`